<template>
  <div>
    <v-row class="title-wrap">
      <v-col
        cols="12"
        class="noticon-title word-type-txt pb-2 d-flex justify-space-between"
      >
        근무기간
      </v-col>
      <v-col cols="12" class="noticon-text word-type-txt mb-3">
        {{ workDate }}
      </v-col>
    </v-row>
    <!--list영역 -->
    <div class="apply-list px-6 overflow-y-auto mx-6 mt-10">
      <div v-for="(item, i) in list" :key="i">
        <div v-if="item.weekNm !== '토요일' && item.weekNm !== '일요일'">
          <div v-if="item.weekNm === '월요일'">
            <v-text-field
              :label="
                item.holidayNm === null
                  ? item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm
                  : item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm +
                    '(' +
                    item.holidayNm +
                    ')'
              "
              v-model="timeNm1"
              v-on:click="applLevelSheet1 = !applLevelSheet1"
              class="bottom--box"
              append-icon="mdi-chevron-right"
              v-bind:disabled="!getDayjs(item, 1)"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="timeCd1"
              readonly
              v-show="false"
            ></v-text-field>
          </div>
          <div v-if="item.weekNm === '화요일'">
            <v-text-field
              :label="
                item.holidayNm === null
                  ? item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm
                  : item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm +
                    '(' +
                    item.holidayNm +
                    ')'
              "
              v-model="timeNm2"
              v-on:click="applLevelSheet2 = !applLevelSheet2"
              class="bottom--box"
              append-icon="mdi-chevron-right"
              v-bind:disabled="!getDayjs(item)"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="timeCd2"
              readonly
              v-show="false"
            ></v-text-field>
          </div>
          <div v-if="item.weekNm === '수요일'">
            <v-text-field
              :label="
                item.holidayNm === null
                  ? item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm
                  : item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm +
                    '(' +
                    item.holidayNm +
                    ')'
              "
              v-model="timeNm3"
              v-on:click="applLevelSheet3 = !applLevelSheet3"
              class="bottom--box"
              append-icon="mdi-chevron-right"
              v-bind:disabled="!getDayjs(item)"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="timeCd3"
              readonly
              v-show="false"
            ></v-text-field>
          </div>
          <div v-if="item.weekNm === '목요일'">
            <v-text-field
              :label="
                item.holidayNm === null
                  ? item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm
                  : item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm +
                    '(' +
                    item.holidayNm +
                    ')'
              "
              v-model="timeNm4"
              v-on:click="applLevelSheet4 = !applLevelSheet4"
              class="bottom--box"
              append-icon="mdi-chevron-right"
              v-bind:disabled="!getDayjs(item)"
              readonly
            ></v-text-field>
            <v-text-field
              :label="
                item.holidayNm === null
                  ? item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm
                  : item.ymd.substring(0, 4) +
                    '-' +
                    item.ymd.substring(4, 6) +
                    '-' +
                    item.ymd.substring(6, 8) +
                    ' ' +
                    item.weekNm +
                    '(' +
                    item.holidayNm +
                    ')'
              "
              readonly
              v-show="false"
            ></v-text-field>
            <v-text-field
              v-model="timeCd4"
              readonly
              v-show="false"
            ></v-text-field>
          </div>
          <div v-if="item.weekNm === '금요일'">
            <v-text-field
              :label="
                item.ymd.substring(0, 4) +
                '-' +
                item.ymd.substring(4, 6) +
                '-' +
                item.ymd.substring(6, 8) +
                ' ' +
                item.weekNm
              "
              v-model="timeNm5"
              v-on:click="applLevelSheet5 = !applLevelSheet5"
              class="bottom--box"
              append-icon="mdi-chevron-right"
              v-bind:disabled="!getDayjs(item)"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="timeCd5"
              readonly
              v-show="false"
            ></v-text-field>
          </div>
        </div>
      </div>
    </div>
    <v-bottom-sheet v-if="applLevelSheet1" v-model="applLevelSheet1">
      <bottom-sheet :title="selecttitle1" :default="timeCd1" :items="codeList1" :codeKey="'timeCd'" :nameKey="'timeNm'" @selectItem="changeApplLine1"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet2" v-model="applLevelSheet2">
      <bottom-sheet :title="selecttitle1" :default="timeCd2" :items="codeList2" :codeKey="'timeCd'" :nameKey="'timeNm'" @selectItem="changeApplLine2"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet3" v-model="applLevelSheet3">
      <bottom-sheet :title="selecttitle1" :default="timeCd3" :items="codeList3" :codeKey="'timeCd'" :nameKey="'timeNm'" @selectItem="changeApplLine3"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet4" v-model="applLevelSheet4">
      <bottom-sheet :title="selecttitle1" :default="timeCd4" :items="codeList4" :codeKey="'timeCd'" :nameKey="'timeNm'" @selectItem="changeApplLine4"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet5" v-model="applLevelSheet5">
      <bottom-sheet :title="selecttitle1" :default="timeCd5" :items="codeList5" :codeKey="'timeCd'" :nameKey="'timeNm'" @selectItem="changeApplLine5"></bottom-sheet>
    </v-bottom-sheet>
   <!-- <bottom-select-work-schedule-time
      :flag="applLevelSheet1"
      :list="codeList1"
      :title="selecttitle1"
      @selectItem="changeApplLine1"
   ></bottom-select-work-schedule-time>
   <bottom-select-work-schedule-time
    :flag="applLevelSheet2"
     :list="codeList2"
      :title="selecttitle1"
     @selectItem="changeApplLine2"
    ></bottom-select-work-schedule-time>
   <bottom-select-work-schedule-time
    :flag="applLevelSheet3"
   :list="codeList3"
      :title="selecttitle1"
      @selectItem="changeApplLine3"
    ></bottom-select-work-schedule-time>
    <bottom-select-work-schedule-time
      :flag="applLevelSheet4"
      :list="codeList4"
     :title="selecttitle1"
     @selectItem="changeApplLine4"
    ></bottom-select-work-schedule-time>
    <bottom-select-work-schedule-time
      :flag="applLevelSheet5"
      :list="codeList5"
      :title="selecttitle1"
      @selectItem="changeApplLine5"
    ></bottom-select-work-schedule-time> -->
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
//import IconApplication from '@/assets/customIcon/IconApplication.vue';
import { mapGetters } from 'vuex';
import { getTimeInfoSub, getWorkScheduleTimeDay } from '@/api/workStatus';
import BottomSelectWorkScheduleTime from '@/components/application/form/BottomSelectWorkScheduleTime.vue';
// eslint-disable-next-line no-unused-vars
import dayjs from 'dayjs';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  data: () => ({
    codeList1: [],
    codeList2: [],
    codeList3: [],
    codeList4: [],
    codeList5: [],
    workDate: '',
    timeNm1: '',
    timeCd1: '',
    timeNm2: '',
    timeCd2: '',
    timeNm3: '',
    timeCd3: '',
    timeNm4: '',
    timeCd4: '',
    timeNm5: '',
    timeCd5: '',
    timeYmd1: '',
    timeYmd2: '',
    timeYmd3: '',
    timeYmd4: '',
    timeYmd5: '',
    list: [],
    saveListOrg: [],
    saveListUpd: [],
    selecttitle1: '시차근무',
    applLevelSheet1: false, // 용도 화면플래그
    applLevelSheet2: false, // 용도 화면플래그
    applLevelSheet3: false, // 용도 화면플래그
    applLevelSheet4: false, // 용도 화면플래그
    applLevelSheet5: false, // 용도 화면플래그
  }),
  components: {BottomSheet, BottomSelectWorkScheduleTime },
  computed: {
    ...mapGetters([
      'GET_DATE',
      'GET_WORK_SCHEDULE_TIME_DATA',
      'GET_WORK_SCHEDULE_TIME_SAVE_ORG',
      'GET_WORK_SCHEDULE_TIME_SAVE_UPD',
      'GET_FILE_SEQ',
    ]),
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',

    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },
  methods: {
    getDayjs(item) {
      // console.log('item : ' + JSON.stringify(item));

      if (item.ymd >= dayjs().format('YYYYMMDD') && item.holidayYn === 'N') {
        return true;
      } else {
        return false;
      }
    },

    changeApplLine1(levelObj) {
      console.dir(levelObj);
      this.timeNm1 = levelObj.timeNm;
      this.timeCd1 = levelObj.timeCd;
      this.applLevelSheet1 = false;
      this.setSaveData(this.timeYmd1, 1);
    },

    changeApplLine2(levelObj) {
      this.timeNm2 = levelObj.timeNm;
      this.timeCd2 = levelObj.timeCd;
      this.applLevelSheet2 = false;
      this.setSaveData(this.timeYmd2, 2);
    },

    changeApplLine3(levelObj) {
      this.timeNm3 = levelObj.timeNm;
      this.timeCd3 = levelObj.timeCd;
      this.applLevelSheet3 = false;
      this.setSaveData(this.timeYmd3, 3);
    },

    changeApplLine4(levelObj) {
      this.timeNm4 = levelObj.timeNm;
      this.timeCd4 = levelObj.timeCd;
      this.applLevelSheet4 = false;
      this.setSaveData(this.timeYmd4, 4);
    },

    changeApplLine5(levelObj) {
      this.timeNm5 = levelObj.timeNm;
      this.timeCd5 = levelObj.timeCd;
      this.applLevelSheet5 = false;
      this.setSaveData(this.timeYmd5, 5);
    },

    setSaveData(ymd, idx) {
      let result = [];

      if (idx === 1) {
        result = this.saveListUpd.map(obj =>
          obj.ymd === ymd
            ? {
                ...obj,
                bfTimeCd: obj.timeCd,
                afTimeCd: this.timeCd1,
                timeNm: this.timeNm1,
                timeCd: this.timeCd1
              }
            : obj,
        );
      }

      if (idx === 2) {
        result = this.saveListUpd.map(obj =>
          obj.ymd === ymd
            ? {
                ...obj,
                bfTimeCd: obj.timeCd,
                afTimeCd: this.timeCd2,
                timeNm: this.timeNm2,
                timeCd: this.timeCd2
              }
            : obj,
        );
      }

      if (idx === 3) {
        result = this.saveListUpd.map(obj =>
          obj.ymd === ymd
            ? {
                ...obj,
                bfTimeCd: obj.timeCd,
                afTimeCd: this.timeCd3,
                timeNm: this.timeNm3,
                timeCd: this.timeCd3

              }
            : obj,
        );
      }

      if (idx === 4) {
        result = this.saveListUpd.map(obj =>
          obj.ymd === ymd
            ? {
                ...obj,
                bfTimeCd: obj.timeCd,
                afTimeCd: this.timeCd4,
                timeNm: this.timeNm4,
                timeCd: this.timeCd4,
              }
            : obj,
        );
      }

      if (idx === 5) {
        result = this.saveListUpd.map(obj =>
          obj.ymd === ymd
            ? {
                ...obj,
                bfTimeCd: obj.timeCd,
                afTimeCd: this.timeCd5,
                timeNm: this.timeNm5,
                timeCd: this.timeCd5,
              }
            : obj,
        );
      }

      this.saveListUpd = result;

      this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_UPD', this.saveListUpd);
      console.dir(result);
    },
    async initPage(){
      this.workDate = this.GET_DATE;

      if (this.GET_WORK_SCHEDULE_TIME_SAVE_UPD.length === 0) {
        await getWorkScheduleTimeDay({
          searchSYmd: this.workDate
              .split('~')[0]
              .replaceAll('-', '')
              .replaceAll(' ', ''),
          searchEYmd: this.workDate
              .split('~')[1]
              .replaceAll('-', '')
              .replaceAll(' ', ''),
        }).then((response) => {
          this.saveListOrg = response.data.data;
          this.saveListUpd = this.saveListOrg;

          //this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_ORG', this.saveListOrg);
          this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_UPD', this.saveListUpd);
        });
      } else {
        this.saveListOrg = this.GET_WORK_SCHEDULE_TIME_SAVE_ORG;
        this.saveListUpd = this.GET_WORK_SCHEDULE_TIME_SAVE_UPD;
      }

      await getWorkScheduleTimeDay({
        searchSYmd: this.$route.params.item.minYmd,
        searchEYmd: this.$route.params.item.maxYmd,
        ssnWw: this.$route.params.item.ww,
      }).then((response) => {
        this.list = response.data.data;
        for (let i = 0; i < this.saveListUpd.length; i++) {
          for (let j = 0; j < this.list.length; j++) {
            if (this.saveListUpd[i].ymd === this.list[j].ymd) {
              this.list[j].timeCd = this.saveListUpd[i].timeCd;
              this.list[j].timeNm = this.saveListUpd[i].timeNm;
            }
          }
        }
      });

      this.timeNm1 = this.list[0].timeNm;
      this.timeNm2 = this.list[1].timeNm;
      this.timeNm3 = this.list[2].timeNm;
      this.timeNm4 = this.list[3].timeNm;
      this.timeNm5 = this.list[4].timeNm;

      this.timeCd1 = this.list[0].timeCd;
      this.timeCd2 = this.list[1].timeCd;
      this.timeCd3 = this.list[2].timeCd;
      this.timeCd4 = this.list[3].timeCd;
      this.timeCd5 = this.list[4].timeCd;

      this.timeYmd1 = this.list[0].ymd;
      this.timeYmd2 = this.list[1].ymd;
      this.timeYmd3 = this.list[2].ymd;
      this.timeYmd4 = this.list[3].ymd;
      this.timeYmd5 = this.list[4].ymd;

      await getTimeInfoSub({
        ymd: this.list[0].ymd,
      }).then((response) => {
        this.codeList1 = response.data.data;
      });

      await getTimeInfoSub({
        ymd: this.list[1].ymd,
      }).then((response) => {
        this.codeList2 = response.data.data;
      });

      await getTimeInfoSub({
        ymd: this.list[2].ymd,
      }).then((response) => {
        this.codeList3 = response.data.data;
      });

      await getTimeInfoSub({
        ymd: this.list[3].ymd,
      }).then((response) => {
        this.codeList4 = response.data.data;
      });

      await getTimeInfoSub({
        ymd: this.list[4].ymd,
      }).then((response) => {
        this.codeList5 = response.data.data;
      });

    }
  },
  created() {
    this.initPage();
  },
  mounted() {

    // this.workDate = this.GET_DATE;
    //
    // let params = {
    //   searchSYmd: this.workDate
    //     .split('~')[0]
    //     .replaceAll('-', '')
    //     .replaceAll(' ', ''),
    //   searchEYmd: this.workDate
    //     .split('~')[1]
    //     .replaceAll('-', '')
    //     .replaceAll(' ', ''),
    // };
    //
    // if (this.GET_WORK_SCHEDULE_TIME_SAVE_UPD.length === 0) {
    //   response = await getWorkScheduleTimeDay(params);
    //
    //   this.saveListOrg = response.data.data;
    //   this.saveListUpd = this.saveListOrg;
    //
    //   //this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_ORG', this.saveListOrg);
    //   this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_UPD', this.saveListUpd);
    // } else {
    //   this.saveListOrg = this.GET_WORK_SCHEDULE_TIME_SAVE_ORG;
    //   this.saveListUpd = this.GET_WORK_SCHEDULE_TIME_SAVE_UPD;
    // }
    //
    // params = {
    //   searchSYmd: this.$route.params.item.minYmd,
    //   searchEYmd: this.$route.params.item.maxYmd,
    //   ssnWw: this.$route.params.item.ww,
    // };
    //
    // let response = await getWorkScheduleTimeDay(params);
    // this.list = response.data.data;
    //
    // for (let i = 0; i < this.saveListUpd.length; i++) {
    //   for (let j = 0; j < this.list.length; j++) {
    //     if (this.saveListUpd[i].ymd === this.list[j].ymd) {
    //       this.list[j].timeCd = this.saveListUpd[i].timeCd;
    //       this.list[j].timeNm = this.saveListUpd[i].timeNm;
    //     }
    //   }
    // }
    //
    // this.timeNm1 = this.list[0].timeNm;
    // this.timeNm2 = this.list[1].timeNm;
    // this.timeNm3 = this.list[2].timeNm;
    // this.timeNm4 = this.list[3].timeNm;
    // this.timeNm5 = this.list[4].timeNm;
    //
    // this.timeCd1 = this.list[0].timeCd;
    // this.timeCd2 = this.list[1].timeCd;
    // this.timeCd3 = this.list[2].timeCd;
    // this.timeCd4 = this.list[3].timeCd;
    // this.timeCd5 = this.list[4].timeCd;
    //
    // params = {
    //   ymd: this.list[0].ymd,
    // };
    //
    // response = await getTimeInfoSub(params);
    // this.codeList1 = response.data.data;
    //
    // params = {
    //   ymd: this.list[1].ymd,
    // };
    //
    // response = await getTimeInfoSub(params);
    // this.codeList2 = response.data.data;
    //
    // params = {
    //   ymd: this.list[2].ymd,
    // };
    //
    // response = await getTimeInfoSub(params);
    // this.codeList3 = response.data.data;
    //
    // params = {
    //   ymd: this.list[3].ymd,
    // };
    //
    // response = await getTimeInfoSub(params);
    // this.codeList4 = response.data.data;
    //
    // params = {
    //   ymd: this.list[4].ymd,
    // };
    //
    // response = await getTimeInfoSub(params);
    // this.codeList5 = response.data.data;
    //
    // console.dir(this.GET_WORK_SCHEDULE_TIME_SAVE_UPD);
  },
};
</script>
